import { render } from "./IconExpand.vue?vue&type=template&id=f253b82c&lang=html"
import script from "./IconExpand.vue?vue&type=script&lang=js"
export * from "./IconExpand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__